import { MedfarDictionariesValidationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/MedfarDictionariesValidationRule";
import { MedfarDictionariesValidationRuleTypeEnum } from "@/Common/Models/MedfarDictionaries/Enums/MedfarDictionariesValidationRuleTypeEnum";

export class MedfarDictionariesValidationHelper {
    private rules: MedfarDictionariesValidationRule[] = [];
    public constructor(validationRules: MedfarDictionariesValidationRule[]) {
        this.rules = validationRules;
    }

    public getValidationRuleForCountryAndRegion(
        ruleType: MedfarDictionariesValidationRuleTypeEnum,
        geoCountryId: string,
        geoStateId: string = null
    ): MedfarDictionariesValidationRule {
        if (!this.rules || !this.rules.length)
            return null;

        const rulesForCountry = this.rules
            .filter(p => p.ValidationRuleTypeId == ruleType && p.GeoCountryId == geoCountryId);

        if (!rulesForCountry || !rulesForCountry.length)
            return null;

        // get the region-agnostic rule for the country if region id is not supplied
        if (!geoStateId)
            return rulesForCountry.firstOrDefault(p => IsNullOrUndefined(p.GeoStateId));

        // otherwise get the region-specific rule - falling back to the region-agnostic if none found
        return rulesForCountry.firstOrDefault(p => p.GeoStateId === geoStateId) ||
            rulesForCountry.firstOrDefault(p => IsNullOrUndefined(p.GeoStateId));
    }

    public getFormattedString(str: string, selector: string, subst: string): string {
        if (IsNullOrWhiteSpace(str))
            return "";

        let result = str;

        if (!IsNullOrWhiteSpace(selector) && !IsNullOrWhiteSpace(subst)) {
            const selRegEx = new RegExp(selector, "i");
            result = str.replace(selRegEx, subst);
        }

        return result;
    }

    public validatePhoneNumber(number: string, countryId: string): boolean {
        const rule = this.getValidationRuleForCountryAndRegion(MedfarDictionariesValidationRuleTypeEnum.PhoneNumber, countryId);
        if (!rule)
            return false;

        const regex = new RegExp(rule.ValidationRegexPattern);
        return regex.test(number);
    }
}
